import React, {useEffect, useState} from 'react';
import './QuestsReminderModal.css';
import PageButton from '../../elements/PageButton/PageButton';
import QuestsButton from '../../elements/QuestsButton/QuestsButton';

const PAGE_ID = 'QuestsReminderModal';

/**
 * Напоминание о невыполненных стартовых заданиях при заходе в главное меню.
 * Показывается не чаще раза в сутки на устройстве (см.
 * questsReminderStorage) и только после всех наградных модалок меню.
 *
 * Самый первый показ на устройстве (isIntro) — знакомство с заданиями, а не
 * напоминание о них.
 *
 * Оформление — как у модалки ежедневной награды (свой оверлей с плавным
 * появлением, а не ModalWindow игры)
 */
const QuestsReminderModal = ({isIntro, onGoToQuests, onClose}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(timeoutId);
  }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => onClose?.(), 300);
  };

  // Переход на страницу заданий закрывает модалку сразу, без затухания:
  // меню под ней все равно сменяется страницей заданий
  const handleGoToQuests = () => {
    onGoToQuests?.();
    onClose?.();
  };

  return (
    <div
      className={`quests-reminder-overlay ${visible ? 'quests-reminder-overlay_visible' : ''}`}
      onClick={handleClose}
      role={'dialog'}
      aria-modal={'true'}
    >
      <div
        className={`quests-reminder-modal ${visible ? 'quests-reminder-modal_visible' : ''}`}
        onClick={(event) => event.stopPropagation()}
      >
        <h2 className={'quests-reminder-title'}>Стартовые задания</h2>

        <img
          className={'quests-reminder-image'}
          src={'/img/chests/chest_tutorial_skins_gold.jpg'}
          alt={'Награды за стартовые задания'}
        />

        <p className={'quests-reminder-text'}>
          {isIntro ? (
            <>
              Для тебя есть <span className={'text-coins'}>стартовые задания</span>,
              <br/>чтобы ты быстро освоил Стратегикон
              <br/>и получил <span className={'text-coins'}>ценные награды</span>!
            </>
          ) : (
            <>
              У тебя еще остались стартовые задания
              <br/>с <span className={'text-coins'}>ценными наградами</span>!
            </>
          )}
        </p>

        <div className={'main-menu-buttons quests-reminder-buttons'}>
          <QuestsButton onClick={handleGoToQuests} pageId={PAGE_ID}/>
          <PageButton
            className={'main-menu-button_secondary'}
            onClick={handleClose}
            pageId={PAGE_ID}
            buttonId={'hide'}
          >
            Скрыть
          </PageButton>
        </div>
      </div>
    </div>
  );
};

export default QuestsReminderModal;
